import { useEffect, useState } from "react";
import BreadCrumbs from "../../ui/BreadCrumbs";
import { Card } from "../../ui/Card";
import Title from "../../ui/Title";
import { fetchAllUserRole } from "../../../config/api";
import { CustomDataTable } from "../../ui/uiImport";
import { useNavigate } from "react-router-dom";
import { StyledButton } from "../../ui/StyledButton";
import { Stack } from "@mui/material";


export const UserRoleColumns = [
    {
        field: "username",
        headerName: "Username",
        minWidth: 140,
        flex: 1,
    },
    {
        field: "email",
        headerName: "Email",
        minWidth: 200,
        flex: 1,
    },
    {
        field: "first_name",
        headerName: "First Name",
        minWidth: 140,
        flex: 1,
    },
    {
        field: "last_name",
        headerName: "Last Name",
        minWidth: 140,
        flex: 1,
    },
    {
        field: "user",
        headerName: "User ID",
        minWidth: 140,
        flex: 1,
    },
    {
        field: "modules",
        headerName: "Modules",
        minWidth: 200,
        flex: 1,
    },
    {
        field: "action",
        headerName: "Action",
        minWidth: 160,
        flex: 1,
        renderCell: (params: { row: any }) => (
            <>
                <ViewDetails userId={params.row?.user} />
            </>
        ),
    },
];


const ViewDetails = ({ userId }: { userId: string }) => {
    const navigate = useNavigate();
    return (
        <StyledButton
            onClick={() =>
                navigate(`/settings/user-role-management/${userId}`)
            }
            sx={{
                textTransform: "none",
            }}
            variant="contained"
        >
            Edit details
        </StyledButton>
    );
};


const UserRoleManagement = () => {
    const [tableData, setTableData] = useState<any>([]);
    const [page, setPage] = useState(1);

    useEffect(() => {
        fetchAllUserRole()
            .then((data) => {
                const userDataArray = data.data.data.map((item: any, index: number) => ({
                    id: index,
                    ...item.userData,
                    user: item.userRoleData.user,
                    // modules: item.userRoleData.modules.join(", ")
                    modules: item.userRoleData.modules.length
                }));
                // console.log("Mapped User Data Array with IDs:", userDataArray);
                setTableData(userDataArray);

            })
            .catch((error) => console.log(error));
    }, []);

    const updatePage = (event: React.ChangeEvent<unknown>, page: number) => {
        event.preventDefault();
        setPage(page);
    };

    const navigate = useNavigate()

    return (
        <>
            <BreadCrumbs
                field="Settings"
                link={"/settings"}
                extra={[
                    {
                        text: "User Role Management",
                    },
                ]}
            />

            <Card>
                <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    marginBottom={"40px"}
                >
                    <Title title="Manage Users" />

                    <StyledButton
                        variant="contained"
                        sx={{
                            textTransform: "none",
                        }}
                        onClick={() =>
                            navigate(`/settings/user-role-management/add`)
                        }
                    >
                        Add User
                    </StyledButton>
                </Stack>
                <CustomDataTable
                    total={tableData.length}
                    totalRow={tableData.page_count}
                    rows={tableData}
                    columns={UserRoleColumns}
                    updatePage={updatePage}
                    page={page}
                />

            </Card >
        </>
    )

}

export default UserRoleManagement;